import axios from 'axios';
import {API_ENTRY} from '../apiConfig';
import {reqStart, reqEnd, toggleSnackbar} from '../actions';


const makeFullUrl = (url, meta = {}) => {
  if (meta.noPrependUrl) {
    return url;
  }
  let full;
  if (url.startsWith('/')) {
    full = `${API_ENTRY}${url}`;
  }
  else {
    full = `${API_ENTRY}/${url}`;
  }
  return full;
}


export const CALL_API = 'callApi';


export default store => next => action => {
  const call = action[CALL_API];
  if (call === undefined) {
    return next(action);
  }

  store.dispatch(reqStart({action: call.type}));

  const config = {
    ...call.config, 
    url: makeFullUrl(call.config.url, call.meta),
  }

  return axios(config)

  .then(response => {
    store.dispatch(reqEnd({
      action: call.type,
      response,
    }))
    if (call.successMessage) {
      const snack = {
        open: true,
        message: call.successMessage,
      }
      setTimeout(() => {
        store.dispatch(toggleSnackbar(snack));
      }, 400)
    } 
    return Promise.resolve(response);
  })

  .catch(error => {
    store.dispatch(reqEnd({
      action: call.type,
      error,
    }))
    if (call.errorMessage) {
      const snack = {
        open: true,
        message: call.errorMessage,
      }
      setTimeout(() => {
        store.dispatch(toggleSnackbar(snack));
      }, 300)
    }
    return Promise.reject(error);
  })
}



// WEBPACK FOOTER //
// ./src/middleware/apiMiddleware.js